import React from "react";
import { FileText } from "lucide-react";
import ModernDataEntryForm from "../components/ModernDataEntryForm";
import PageHeader from "../components/layout/PageHeader";
import { useAuthContext } from "../context/AuthContext";

const DataEntryPage: React.FC = () => {
  const { assignedUnits, role } = useAuthContext();

  if (role !== "admin" && assignedUnits.length === 0) {
    return (
      <div className="p-4 text-center text-text-secondary">No units assigned.</div>
    );
  }
  
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6">
      <div className="w-full max-w-7xl mx-auto">
        <PageHeader 
          icon={<FileText size={24} />}
          title="Data Entry"
          subtitle="Record and manage daily expense transactions"
        />

        {/* Form with built-in tab navigation */}
        <ModernDataEntryForm layout="auto" />
      </div>
    </div>
  );
};

export default DataEntryPage;
